import axios from '@/utils/api'

const state = {
}

const getters = {
}
const actions = {
  async cadastroUcFinalizar ({ commit }, informacoesUcDto) {
    try {
      const data = await axios({
        method: 'post',
        data: informacoesUcDto,
        url: 'cadastro-uc/finalizar'
      })
      return data
    } catch (e) {
      console.error('Erro ao cadastrar', e)
    }
  },
  async cadastroUcSalvar ({ commit }, informacoesUcDto) {
    try {
      const data = await axios({
        method: 'post',
        data: informacoesUcDto,
        url: 'cadastro-uc/salvar'
      })
      return data
    } catch (e) {
      console.error('Erro ao cadastrar', e)
    }
  },
  async cadastroUcNovo ({ commit }) {
    try {
      const data = await axios({
        method: 'get',
        url: 'cadastro-uc/criarNovo'
      })
      return data
    } catch (e) {
      console.error('Erro ao cadastrar', e)
    }
  },
  async cadastroUcById ({ commit }, id) {
    try {
      const data = await axios({
        method: 'get',
        url: `cadastro-uc/byId/${id}`
      })
      return data
    } catch (e) {
      console.error('Erro ao cadastrar', e)
    }
  },
  async cadastroUcFiltro ({ commit }, pagina) {
    try {
      const data = await axios({
        method: 'get',
        url: `cadastro-uc/listar?page=${pagina}`
      })
      return data
    } catch (e) {
      console.error('Erro ao cadastrar', e)
    }
  },
  async getJson ({ commit }, protocolo) {
    try {
      const data = await axios({
        method: 'get',
        url: `cadastro-uc/getJson/${protocolo}`
      })
      return data
    } catch (e) {
      console.error('Erro ao cadastrar', e)
    }
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/cadastroUc.js